import VoucherCard from "./VoucherCard"

const VOUCHERS = [
    {
        title: "GIẢM 4%",
        desc: "tối đa 20.000đ, cho đơn hàng từ 2 chai",
        expired: "31/12/2025",
        collected: false,
    },
    {
        title: "GIẢM 0.5%",
        desc: "Không giới hạn khi thanh toán chuyển khoản",
        expired: "31/12/2025",
        collected: true,
    },
    {
        title: "GIẢM 4%",
        desc: "tối đa 20.000đ, cho đơn hàng từ 2 chai",
        expired: "31/12/2025",
        collected: false,
    },
    {
        title: "GIẢM 0.5%",
        desc: "Không giới hạn khi thanh toán chuyển khoản",
        expired: "31/12/2025",
        collected: true,
    },
    {
        title: "GIẢM 4%",
        desc: "tối đa 20.000đ, cho đơn hàng từ 2 chai",
        expired: "31/12/2025",
        collected: false,
    },
    {
        title: "GIẢM 0.5%",
        desc: "Không giới hạn khi thanh toán chuyển khoản",
        expired: "31/12/2025",
        collected: true,
    },
    {
        title: "GIẢM 4%",
        desc: "tối đa 20.000đ, cho đơn hàng từ 2 chai",
        expired: "31/12/2025",
        collected: false,
    },
    {
        title: "GIẢM 0.5%",
        desc: "Không giới hạn khi thanh toán chuyển khoản",
        expired: "31/12/2025",
        collected: true,
    },
    {
        title: "GIẢM 4%",
        desc: "tối đa 20.000đ, cho đơn hàng từ 2 chai",
        expired: "31/12/2025",
        collected: false,
    },
    {
        title: "GIẢM 0.5%",
        desc: "Không giới hạn khi thanh toán chuyển khoản",
        expired: "31/12/2025",
        collected: true,
    },
]

export default function VoucherList() {
    return (
        <div className="MuiGrid-root styles_voucherList_container__wcJki MuiGrid-container">
            {VOUCHERS.map((item, index) => (
                <VoucherCard
                    key={index}
                    title={item.title}
                    desc={item.desc}
                    expired={item.expired}
                    collected={item.collected}
                />
            ))}
        </div>
    )
}
